import 'assets/styles/app.scss';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle';

// Bundle every JS in /components/**.js into app.js
const componentsCtx = require.context('../../components', true, /\.js$/);

// derive component name from path like './header/header.js' or './header.js'
function nameFromKey(key) {
	// ./name/name.js  -> name
	// ./name.js       -> name
	const m = key.match(/^\.\/([^/]+)(?:\/\1)?\.js$/);
	if (m) return m[1];
	// fallback: last segment without .js
	return key.replace(/^.\//, '').split('/').pop().replace(/\.js$/, '');
}

document.addEventListener('DOMContentLoaded', () => {
	componentsCtx.keys().forEach(key => {
		const mod = componentsCtx(key);
		const init = mod && mod.default;
		if (typeof init !== 'function') return;

		const name = nameFromKey(key);
		const nodes = document.querySelectorAll(`[data-component="${name}"]`);
		if (!nodes.length) return; // don't run where it's not used

		nodes.forEach(el => {
			try {
				// Pass the host element so components can scope queries if they want.
				init(el);
			} catch (e) {
				console.error(`Error init ${name}:`, e);
			}
		});
	});

	// Bootstrap tooltips
	document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(
		el => new bootstrap.Tooltip(el)
	);
});
